export default {
  primary: {
    backgroundColor: 'transparent',
    color: 'light',
    border: 'none',
    border: 'solid 1px',
    transition: 'all ease-in-out 0.7s',
    backgroundSize: '100% 204%',
    backgroundImage: 'linear-gradient(to bottom,rgba(0,0,0,0) 50%, #202020 50%)',
    borderColor: 'light',
    padding: '1rem 2rem',
    fontFamily: 'heading',
    fontWeight: 'normal',
    fontSize: '1rem',
    ':hover': {
      backgroundColor: 'transparent',
      backgroundPosition: '0% -98%',
      color: 'light',
      borderColor: 'primary'
    }
  },
  secondary: {
    backgroundColor: '#202020',
    color: 'light',
    border: 'none',
    border: 'solid 1px',
    transition: 'all ease-in-out 0.7s',
    backgroundSize: '100% 204%',
    backgroundImage: 'linear-gradient(to bottom,#202020 50%, transparent 50%)',
    borderColor: 'primary',
    padding: '1rem 2rem',
    fontFamily: 'heading',
    fontWeight: 'normal',
    fontSize: '1rem',
    ':hover': {
      backgroundColor: 'transparent',
      backgroundPosition: '0% -98%',
      color: 'primary',
      borderColor: 'primary'
    }
  }
}
